import { AiOutlineFilePdf, AiFillCreditCard } from "react-icons/ai";
import { RiEyeLine } from "react-icons/ri";

import { Link } from "react-router-dom";
import { handleDownload } from "../../Functions/Utils";

const handleDownloadPdf = (id) => {
  handleDownload("commitment_pdf", "engagement", "id=" + id);
};

export const config = (onView, withFilter) => [
  {
    name: "Numéro contrat",
    selector: (row) => row.contract_number,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Immatriculation",
    selector: (row) =>
      row.registration_number
        ? row.registration_number
        : row.first_registration_number + "/" + row.last_registration_number,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Statut",
    sortable: true,
    filterable: withFilter,
    width: "130px !important",
    selector: (row) => row.status && row.status.title,
    conditionalCellStyles: [
      {
        when: (row) => row.status && row.status.type === "rejected",
        classNames: ["chip-component danger"],
      },
      {
        when: (row) =>
          row.status && row.status.type === "validation_in_progress",
        classNames: ["chip-component warning"],
      },
      {
        when: (row) => row.status && row.status.type === "validated",
        classNames: ["chip-component success"],
      },
      {
        when: (row) => row.status && row.status.type === "in_progress",
        classNames: ["chip-component warning"],
      },
      {
        when: (row) =>
          row.status && row.status.type === "additional_information",
        classNames: ["chip-component primary"],
      },
    ],
  },
  {
    name: "Assurances",
    selector: (row) => row.insurance_name,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Date Demande",
    selector: (row) => row.created_at,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Type de changement",
    selector: (row) =>
      row.changement_type == "reset_risque"
        ? "Annulation tous risques"
        : "Changement d’assurance",
    sortable: true,
    filterable: withFilter,
    width: "130px !important",
  },
  {
    name: "Engagement",
    selector: (row) =>
      row.status &&
      row.status.type === "validation_in_progress" &&
      row.changement_type == "reset_risque",
    cell: (row) => (
      <>
        {row.status &&
          row.status.type === "validation_in_progress" &&
          row.changement_type == "reset_risque" && (
            <Link onClick={() => handleDownloadPdf(row.id)}>
              <AiOutlineFilePdf />
            </Link>
          )}
      </>
    ),
  },
  {
    name: "Fichier",
    selector: (row) => row.files && row.files,
    cell: (row) => (
      <>
        {row.files && (
          <Link to={row.files} target="_blank" download>
            <AiOutlineFilePdf />
          </Link>
        )}
      </>
    ),
  },
  {
    name: "Payer",
    selector: (row) => row.files && row.files,
    cell: (row) => (
      <>
        <AiFillCreditCard style={{ color: "#ccc" }} />
      </>
    ),
  },
  {
    name: "Action",
    selector: (row) => row.commitement_pdf,
    cell: (row) => (
      <>
        {row.status &&
        row.status.type === "validation_in_progress" &&
        row.changement_type == "reset_risque" ? (
          <Link to={`/list-insurance-requests/commitement-pdf/${row.id}`}>
            <RiEyeLine />
          </Link>
        ) : (
          ""
        )}
      </>
    ),
  },
];
